<template>
  <ValidationProvider
    v-slot="{ errors }"
    :vid="vid"
    rules="numeric|between:1,31"
    name="自己評価提出期限日">
    <div class="d-flex align-items-center font-weight-bold mb-2">
      <div>翌月の</div>
      <b-form-input
        v-model="_value"
        class="mx-2"
        style="width: 80px;" />
      <div>日まで</div>
    </div>
    <BaseErrorMessage :errors="[...errors, ...responseFieldErrors]" />
  </ValidationProvider>
</template>

<script>
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  components: {
    BaseErrorMessage
  },
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    responseErrors: {
      type: Object,
      default: null
    },
    vid: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v ? v : null)
      }
    },
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || []
    }
  }
}
</script>

<style>

</style>